import * as React from 'react';
import MarkdownRenderer from '../../common/MarkdownRenderer';
import PrintDisclaimers from './PrintDisclaimers';
import { productType } from '../../../../../../infrastructure/ProductType';

export interface ITypeProductLegacy {
  product: any;
  pageNumber?: number;
}

export default class TypeProductLegacy extends React.Component<ITypeProductLegacy> {
  image: any;
  constructor(props: ITypeProductLegacy) {
    super(props);
  }
  componentDidMount() {
    if (!this.props.product.templateType) {
      this.checkHeight(this.image);
    }
  }
  componentWillReceiveProps() {
    if (!this.props.product.templateType) {
      this.checkHeight(this.image);
    }
  }
  checkHeight = (img: any) => {
    if (img) {
      img.onload = function () {
        img.classList.remove('wider');
        const w = this.width || this.clientWidth;
        const h = this.height || this.clientHeight;
        const widerRatio = 1.6;
        if (w / h > widerRatio && (w > this.parentNode.clientWidth / widerRatio)) {
          this.classList.add('wider');
        }
        img.onload = null;
      };
    }
  }

  renderImageArea(imageArea: string) {
    if (imageArea.indexOf('.svg') > -1 && typeof window === 'undefined') {
      return <object data={imageArea} />;
    }
    return <img src={imageArea} alt="" />;
  }

  buildCatalogProduct() {
    const styleMap = new Map();

    styleMap.set('Adjuvant', {
      backgroundImage: 'linear-gradient(180deg, #eb7f2d 0%, #e57d2b 50%, #a1591b 100%)',
    });
    styleMap.set('Crop Protection', {
      backgroundImage: 'linear-gradient(180deg, #276787 0%, #276787 50%, #1b4561 100%)',
    });
    styleMap.set('Plant Nutrition', {
      backgroundImage: 'linear-gradient(180deg, #61b94b 0%, #5fb94d 50%, #337527 100%)',
    });
    styleMap.set('Seed Treatment', {
      backgroundImage: 'linear-gradient(180deg, #e5592d 0%, #e3572d 50%, #9d3d19 100%)',
    });

    const {
      statement,
      features,
      icon,
      logo,
      group,
      category_2,
      rates,
      grower_benefits,
      category,
      recomendation_1,
      separator_1,
      recomendation_2,
      separator_2,
      recomendation_3,
      imageArea,
      variableText,
      disclaimers,
      templateType
    } = this.props.product;
    const pageNumber = this.props.pageNumber;

    const mainDisclaimer = {
      value: '',
      description: 'ALWAYS READ AND FOLLOW LABEL DIRECTIONS',
    };
    const printDisclaimers = disclaimers.filter((disclaimer: any) => { return disclaimer.value !== '#'; });
    printDisclaimers.unshift(mainDisclaimer);

    return (
      <div>
        <div className="crop-page-side">
          <div className='page-number'><span>{pageNumber}</span></div>
          <div className='crop-page-category' style={styleMap.get(category)}>
            <span>{category}</span>
          </div>
        </div>
        <div className="crop-page-drop">
          <div className="crop-drop-content">
            <div className="crop-page-group">
              {group ?
                <div className={`group ${category_2.replace(/\//, '_')}`}>
                  <ul>
                    <li>{category_2}</li>
                    <li>{group}</li>
                    <li>group</li>
                  </ul>
                </div>
                : null}
            </div>
            <div className="crop-drop-head">
              {logo && <img alt="" src={logo} />}
              {icon && <img alt="" src={icon} />}
            </div>
            {statement && templateType !== 'type3' ? <MarkdownRenderer className={"crop-drop-cont"} markdown={statement} /> : null}
            <div className="crop-drop-features">
              <span className="crop-drop-title">FEATURES:</span>
              <MarkdownRenderer markdown={features} />
            </div>
            <div className="crop-drop-benefits">
              <span className="crop-drop-title">GROWER BENEFITS:</span>
              <MarkdownRenderer markdown={grower_benefits} />
            </div>
            {templateType !== 'type2' ?
              <div className="crop-drop-rates">
                <span className="crop-drop-title">rates:</span>
                <span className="crop-drop-rates-val">{rates}</span>
              </div>
              : null}
            <div className="crop-drop-additional">
              {templateType === 'type2' ?
                <div className="crop-drop-rates">
                  <span className="crop-drop-title">rates:</span>
                  <span className="crop-drop-rates-val">{rates}</span>
                </div>
                : null}
              {variableText && (
                <div className="crop-drop-variableText">
                  <span className="crop-drop-title">{variableText.title}:</span>
                  <p className="crop-drop-variableText-val">{variableText.content}</p>
                </div>)}
              {recomendation_1 ?
                <div className="crop-drop-recommendation">
                  <span className="crop-drop-title">Adjuvant Recommendation:</span>
                  {recomendation_1 ? <img className="crop-drop-rec_1" src={recomendation_1} alt="." /> : null}
                  {separator_1 ? <span className="crop-drop-div_1">{separator_1}</span> : null}
                  {recomendation_2 ? <img className="crop-drop-rec_2" src={recomendation_2} alt="." /> : null}
                  {separator_2 ? <span className="crop-drop-div_2">{separator_2}</span> : null}
                  {recomendation_3 ? <img className="crop-drop-rec_3" src={recomendation_3} alt="." /> : null}
                </div>
                : null}
            </div>
            {imageArea ?
              <div className="crop-drop-image">
                { this.renderImageArea(imageArea) }
              </div>
              : null}
            <div className="crop-drop-disclaimer">
              <PrintDisclaimers
                disclaimers={printDisclaimers}
                className="crop-drop-disclaimer-val"
              />
            </div>
          </div>
        </div>
        <div className="crop-page-footer"></div>
      </ div>
    );
  }
  buildBrochureProduct() {
    const {
      statement,
      features,
      icon,
      logo,
      group,
      rates,
      category,
    } = this.props.product;
    const categoryIcon = `/images/Products/Icons for Product Category/${category}.svg`;
    return (
      <div>
        <div className="crop-page-drop">
          <div className="crop-drop-content">
            <div className="crop-drop-head">
              {logo && <img alt="" src={logo} ref={(img) => { this.image = img; }} />}
              {icon && <img alt="" src={icon} />}
            </div>
            <div className="crop-drop-line">
              <div className="crop-drop-line-left">
                <img src={categoryIcon} alt={`${category}`} className="crop-drop-line-ico" />
                <span className="crop-drop-category">{category}</span>
              </div>
              <div className="crop-drop-line-right">
                {group && <span className="crop-drop-group">group: <span>{group}</span></span>}
              </div>
            </div>
            <MarkdownRenderer className={"crop-drop-cont"} markdown={statement} />
            <div className="crop-drop-benefits">
              <span className="crop-drop-title">GROWER BENEFITS:</span>
              <MarkdownRenderer markdown={features} />
            </div>
            <div className="crop-drop-rates">
              <span className="crop-drop-title">rates:</span>
              <span className="crop-drop-rates-val">{rates}</span>
            </div>
          </div>
        </div>
      </ div>
    );
  }
  render() {
    const brochureTemplate = productType.Brochure.toUpperCase() == this.props.product.type.toUpperCase();
    return brochureTemplate ? this.buildBrochureProduct() : this.buildCatalogProduct();
  }

}


// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageTypes/TypeProductLegacy.tsx